/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Insert_ReferenceInputs */



/**
* | output |
* | --- |
* | "Insert Reference" |
*
* @param {Chat_Mentions_Insert_ReferenceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_insert_reference = /** @type {((inputs?: Chat_Mentions_Insert_ReferenceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Insert_ReferenceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Referenz einfügen")
	return /** @type {LocalizedString} */ ("Insert Reference")
});